import {makeAutoObservable} from "mobx"
import Category from "../../store/entities/Category"
import CategoriesApi from "../../api/CategoriesApi"
import {adaptersSettings} from "../generalOfferFields/GeneralProductFields"
import entityCompareController from "./EntityCompareController"

export class AttributesCompare {

    constructor() {
        makeAutoObservable(this)
    }

    private _categories: Category[] = []

    get categories(): Category[] {
        return this._categories
    }

    private _adaptersSettings: adaptersSettings | undefined

    get adaptersSettings(): adaptersSettings | undefined {
        return this._adaptersSettings
    }

    get isCategoriesLoad() {
        return this._categories.length > 0
    }

    loadCategories() {
        CategoriesApi.getWaAndOzonCategories()
            .then((result) => {
                for (const data of result.data.data) {
                    this._categories.push(new Category(+data.id, data))
                }
            })
    }


    loadCategoryAttributesValues(category_id: string, attribute_id: string) {
        entityCompareController.loadFeatureAndAttributePairs({
            category_id: category_id,
            attribute_id: attribute_id
        })
    }

    findOrLoadCategory(category_id: string): Category {
        for (const category of this._categories) {
            if (+category_id === category.id) {
                if (!category.is_attributes_load) {
                    category.loadAttributes()
                }
                return category
            }
        }
        const category = new Category(+category_id)
        category.loadAttributes()
        return category
    }
}

export const attributesCompare = new AttributesCompare()